// CurvesForm.jsx
import UniversalEditableTable from '../UniversalComponents/UniversalEditableTable'//'@fileops/swmm-react'
import { Grid, Box } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Curves Form is a table editor usually shown when clicking on Curves->'section'->'id'. 
 * This form is contained within CurvesDialog.
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {string} target The name of the curve targetted by this form.
 * @param {string} subkeysSection The name of the curve type (PUMP1, CONTROL, DIVERSION, ...)
 * @param {function} saveEdits UniversalEditableTable comes with it's own 'save' button, so normal
 * 'save edits' dialog interactions are passed to that button.
 * @returns UI for interactive swmm modeling.
 */
export default function CurvesForm({ model, target, subkeysSection, saveEdits }) {

  // Possibly not necessary, saveEdits could be called within the updateData parameter.
  function updateTableData (data){
    if(model && model.CURVES){
      saveEdits(data)
    }
  }
  
  return(
    <>
    {
      <>
      <Grid container>
        <Grid item xs={12}>
        {
          <Grid container spacing={2} padding={2}>
            <Box sx={{width: '100%' }}>
              <UniversalEditableTable colNames={['x', 'y']} theData={(model && model.CURVES[subkeysSection])?model.CURVES[subkeysSection][target]:[]} updateData={updateTableData} />
            </Box>
          </Grid>
        }
        </Grid>
      </Grid>
      </>
        }
    </>
  )
} 